module.exports = {
  EXPAK_1_HOMECALL: "2^01",
  EXPAK_1_BY_12: "2^03",
  EXPAK_1_BY_10_30: "2^04",
  EXPAK_1_SAT_BY_12: "2^05",
  EXPAK_1_SAT_BY_10_30: "2^06",
  PARCEL_BY_10_30: "2^08",
  PARCEL_SATURDAY_BY_10_30: "2^09",
  PARCEL_TWO_DAY: "2^11",
};
